import { useRecoilValue } from 'recoil';
import React ,{useEffect, useState } from 'react';
import { studentsAtom } from '_state';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { HomeworkChart } from '_components/dashboard';
import { Row, Col, Button } from 'antd';
import { useClassWrapper } from '_helpers';
import { classSlug } from '_helpers/normalize';

export { Dashboard };


function Dashboard() {
    const student = useRecoilValue(studentsAtom);
    const classWrapper = useClassWrapper();
    const userData = JSON.parse(localStorage.getItem("userData"));

    const [dashProperties, setDashProperties] = useState({
        className: "Không hiển thị được tên lớp",
        teacherName: "Không hiển thị được tên CVHT",
        studentCount: 0,
        classID: ""
    })

    useEffect(() =>{
        console.log("Reconstruct GPADash")
        async function initDashboard() {
            if (!classWrapper.curClass) return;
            var classNameTemp = classWrapper.curClass.class_name;
            var classIDTemp = classWrapper.curClass.class_id;
            var teacherNameTemp = userData.name;
            var studentCountTemp = 0;
            if ("length" in student) studentCountTemp = student.length;
            setDashProperties({
                className : classNameTemp,
                teacherName : teacherNameTemp,
                studentCount : studentCountTemp,
                classID : classIDTemp
            });
        };
        initDashboard();
    },[classWrapper.curClass, student, userData.name]);

    const classPath = classWrapper.curClass ? classSlug(classWrapper.curClass) : dashProperties.classID;

    return (
        <div className="att2-page soft-in">
            <div className="att2-head">
                <div className="att2-head-l">
                    <h1 className="att2-title">Bảng theo dõi</h1>
                    {dashProperties.className && <div className="att2-sub">{dashProperties.className}</div>}
                </div>
            </div>
            <Row gutter={[16, 16]}>
                {/* Class info */}
                <Col xs={24} sm={24} md={16} lg={16}>
                    <div className="att2-metric" style={{ height: '100%' }}>
                        <div className="stat-card-label">Lớp hiện tại</div>
                        <div className="stat-card-value">{dashProperties.className}</div>
                        <div className="stat-card-label" style={{ marginTop: 12 }}>Giáo viên</div>
                        <div className="stat-card-value">{dashProperties.teacherName}</div>
                    </div>
                </Col>
                {/* Student count */}
                <Col xs={24} sm={24} md={8} lg={8}>
                    <div className="att2-metric stat-ok" style={{ height: '100%' }}>
                        <div className="stat-card-label">Sĩ số lớp</div>
                        <div className="stat-card-value">
                            {dashProperties.studentCount}
                            <span style={{ fontSize: '1rem', fontWeight: 400, marginLeft: 6 }}>học sinh</span>
                        </div>
                        <div style={{ marginTop: 16 }}>
                            <Link to={`/${classPath}/studentinfo`}>
                                <Button icon={<InfoCircleOutlined />}>Xem danh sách</Button>
                            </Link>
                        </div>
                    </div>
                </Col>
            </Row>
            <HomeworkChart classId={dashProperties.classID} />
        </div>
    )
}
